import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1057.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,588.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M5136 8498 c-250 -21 -572 -111 -772 -213 -212 -109 -344 -214 -526
-420 -96 -109 -251 -403 -272 -517 -4 -20 -13 -39 -21 -42 -9 -3 -15 -18 -15
-36 0 -17 -4 -38 -9 -48 -10 -18 -39 -153 -39 -187 -1 -11 -3 -32 -5 -46 -7
-36 -10 -256 -4 -299 3 -34 18 -104 38 -181 5 -20 9 -48 9 -63 0 -15 9 -36 20
-48 11 -12 19 -27 18 -32 -2 -15 12 -48 28 -67 8 -8 15 -24 17 -35 4 -25 46
-114 65 -136 7 -9 11 -22 6 -29 -4 -7 -3 -10 4 -5 6 3 13 2 17 -4 3 -5 0 -10
-7 -11 -12 -1 0 -7 50 -24 12 -4 22 -11 22 -16 0 -5 -8 -6 -17 -2 -15 5 -16 4
-5 -8 7 -8 16 -14 21 -14 4 0 25 -19 47 -42 23 -24 39 -43 37 -43 -3 0 9 -13
25 -30 17 -16 35 -30 41 -30 6 0 11 -4 11 -8 0 -4 14 -13 31 -19 17 -7 28 -16
25 -22 -4 -5 -1 -13 5 -17 6 -3 15 -1 20 7 6 10 11 6 18 -14 6 -15 15 -27 21
-27 16 0 144 -62 152 -74 4 -6 11 -11 15 -12 4 0 19 -5 33 -11 31 -13 115 -39
154 -48 23 -5 27 -8 15 -16 -11 -7 -8 -9 11 -11 45 -3 55 -5 95 -16 113 -33
269 -23 325 20 26 20 46 83 115 348 36 135 44 166 110 404 20 70 34 130 31
133 -3 3 -45 14 -93 24 -178 36 -345 128 -425 234 -60 79 -83 160 -82 285 0
81 5 118 21 162 42 114 140 235 238 292 40 24 145 64 188 71 12 3 76 14 142
26 159 29 265 34 383 19 53 -7 109 -14 123 -15 14 -2 36 -8 47 -14 11 -6 29
-11 38 -11 10 0 26 -7 35 -16 10 -9 32 -18 49 -20 17 -2 50 -13 75 -24 24 -11
50 -20 58 -20 8 0 20 -7 27 -15 7 -8 21 -15 31 -15 10 0 20 -9 24 -19 3 -10
20 -29 38 -41 40 -28 122 -128 132 -161 4 -13 19 -41 31 -61 13 -21 24 -42 24
-48 0 -13 30 -73 40 -80 8 -6 18 -43 32 -125 26 -157 39 -166 208 -152 41 4
174 9 295 12 121 3 238 10 260 16 22 6 57 13 79 16 22 3 33 8 27 13 -7 4 20
10 60 14 39 3 76 9 82 13 14 8 2 171 -23 313 -25 144 -89 349 -142 459 -99
203 -275 409 -464 542 -83 59 -247 149 -350 192 -155 65 -426 129 -624 147
-134 12 -402 11 -544 -2z m809 -58 c55 -12 105 -26 111 -31 6 -5 19 -7 28 -3
9 3 16 1 16 -5 0 -6 13 -11 30 -11 16 0 39 -4 52 -10 13 -5 68 -27 123 -49
130 -51 273 -128 323 -171 6 -6 12 -7 12 -3 0 4 4 3 8 -2 4 -6 25 -23 47 -39
109 -80 325 -323 325 -366 0 -6 3 -10 8 -10 7 0 24 -30 77 -140 30 -63 71
-179 80 -229 3 -19 10 -42 16 -52 11 -22 38 -188 45 -279 2 -36 6 -77 9 -92 2
-16 0 -28 -5 -28 -9 0 -14 22 -25 115 -9 74 -34 200 -57 285 -11 41 -24 89
-28 105 -9 38 -95 226 -122 270 -162 256 -350 425 -629 565 -162 82 -396 148
-699 196 l-85 13 120 -4 c66 -2 165 -14 220 -25z m-1469 -1582 c9 -27 20 -48
25 -48 6 0 8 -4 5 -9 -14 -23 124 -170 209 -222 17 -11 24 -19 17 -19 -45 0
-187 129 -237 214 -28 48 -55 150 -54 197 1 29 3 26 10 -16 6 -27 17 -71 25
-97z m321 -324 c-6 -6 -47 9 -47 17 0 5 11 3 25 -3 14 -6 24 -13 22 -14z m69
-29 c25 -19 15 -19 -27 0 -25 10 -29 14 -13 15 11 0 29 -7 40 -15z m84 -25
c11 -7 5 -8 -20 -4 -43 8 -51 14 -19 14 13 0 31 -5 39 -10z m80 -20 c0 -5 -2
-10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z"
          />
          <path
            d="M5379 7378 c-20 -49 -139 -162 -206 -194 -31 -16 -93 -38 -137 -50
l-81 -21 -8 -49 c-4 -27 -12 -58 -17 -69 -16 -36 -31 -185 -18 -185 4 0 8 -7
8 -15 0 -18 22 -23 130 -29 47 -3 95 -8 107 -11 29 -9 50 -61 35 -86 -7 -11
-8 -19 -3 -19 9 0 6 -26 -6 -60 -3 -8 -5 -41 -3 -72 1 -32 -3 -58 -8 -58 -5 0
-14 -26 -20 -57 -15 -83 -32 -147 -40 -153 -5 -3 -16 -48 -26 -100 -10 -52
-23 -99 -27 -105 -5 -5 -9 -20 -9 -35 0 -14 -10 -45 -21 -70 -11 -25 -22 -56
-24 -70 -7 -55 -27 -155 -32 -164 -4 -5 -8 -21 -9 -35 -7 -55 -9 -66 -17 -72
-4 -3 -12 -33 -17 -67 -10 -58 -9 -63 12 -84 22 -22 29 -23 173 -21 191 3 197
0 202 -84 1 -35 -1 -63 -6 -63 -5 0 -10 -33 -11 -72 -2 -72 -7 -143 -10 -143
-2 0 -6 -27 -13 -80 -3 -22 -13 -65 -21 -95 -9 -30 -16 -74 -16 -98 0 -29 -5
-45 -15 -48 -10 -4 -12 -11 -7 -18 16 -19 20 -55 8 -60 -8 -3 -7 -7 3 -14 11
-8 10 -15 -5 -42 -12 -21 -15 -34 -8 -37 7 -2 8 -23 1 -69 -18 -128 12 -95
145 156 25 47 81 150 125 230 204 370 248 449 281 510 19 36 38 70 42 75 4 6
27 46 50 90 75 139 129 233 143 250 4 6 13 18 20 28 12 17 13 17 14 -2 1 -11
-2 -23 -8 -26 -17 -11 -9 -23 11 -18 16 4 19 2 14 -11 -3 -9 -11 -16 -16 -16
-6 0 -7 -11 -4 -25 5 -18 2 -27 -9 -32 -9 -3 -14 -12 -11 -20 3 -8 1 -11 -4
-8 -6 3 -10 -4 -10 -17 0 -13 -25 -74 -55 -137 -74 -152 -73 -202 4 -226 17
-5 20 -9 10 -15 -9 -6 -5 -11 14 -15 15 -4 27 -11 27 -16 0 -5 8 -9 18 -9 22
0 112 -58 119 -77 3 -7 11 -13 17 -13 7 0 33 -20 58 -44 35 -33 48 -55 58 -95
6 -28 15 -51 18 -51 4 0 8 -21 10 -47 1 -26 8 -50 14 -54 9 -6 9 -11 -1 -22
-9 -12 -9 -17 0 -23 8 -5 10 -29 5 -83 -4 -42 -7 -83 -8 -91 0 -8 -4 -19 -8
-25 -4 -5 -10 -23 -14 -39 -23 -93 -167 -219 -335 -290 -148 -64 -266 -88
-455 -94 -194 -5 -300 6 -448 49 -361 103 -566 325 -641 696 l-20 101 -42 4
c-23 1 -236 2 -473 0 l-430 -2 -12 -72 c-7 -39 -21 -87 -32 -107 -16 -28 -18
-41 -10 -75 5 -23 8 -57 5 -77 -3 -20 0 -46 6 -56 6 -12 6 -24 1 -29 -5 -5 -2
-29 7 -57 13 -39 13 -51 3 -57 -9 -6 -7 -10 9 -15 13 -4 20 -9 17 -12 -3 -3 1
-21 9 -40 8 -19 13 -38 10 -42 -5 -10 17 -75 33 -93 6 -8 9 -17 6 -20 -3 -3 9
-28 25 -56 17 -27 31 -59 31 -70 0 -12 6 -25 13 -29 15 -10 37 -48 37 -66 0
-8 9 -22 20 -32 11 -10 20 -24 20 -32 0 -12 12 -17 33 -14 4 0 7 -4 7 -9 0 -6
-4 -10 -10 -10 -5 0 -10 -7 -10 -15 0 -8 7 -15 16 -15 9 0 18 -9 21 -20 3 -11
11 -20 19 -20 7 0 21 -16 30 -35 9 -19 22 -35 28 -35 12 0 96 -83 96 -95 0
-17 63 -64 97 -71 30 -6 33 -9 16 -12 -33 -5 -28 -22 6 -22 16 0 34 -7 41 -15
7 -8 35 -25 61 -38 27 -12 52 -30 55 -40 3 -9 9 -15 14 -12 5 3 15 -2 23 -10
9 -8 23 -15 31 -15 9 0 16 -5 16 -11 0 -5 4 -8 9 -4 5 3 12 1 16 -5 3 -5 15
-10 26 -10 23 0 79 -27 94 -45 6 -7 36 -21 68 -30 32 -10 60 -22 63 -26 3 -5
20 -9 39 -9 19 0 37 -4 40 -10 3 -6 23 -10 43 -11 20 0 31 -3 25 -6 -30 -11
-9 -24 35 -22 27 1 54 -1 60 -5 7 -4 31 -7 55 -8 23 0 47 -3 52 -7 30 -18 74
-28 85 -17 8 8 13 7 19 -2 5 -8 45 -14 122 -16 63 -3 131 -8 153 -12 21 -4 41
-3 45 3 3 5 47 6 111 2 57 -4 109 -5 114 -1 5 3 37 7 70 9 96 6 106 8 106 16
0 4 12 7 28 7 15 0 61 7 102 16 41 9 89 17 107 17 18 1 38 8 44 15 7 6 24 12
37 12 13 0 33 5 45 12 12 6 40 15 62 20 56 12 56 12 94 36 19 11 38 19 43 16
4 -3 11 2 14 10 3 9 15 16 26 16 18 0 50 14 98 41 8 5 26 15 40 21 14 7 31 21
38 30 7 10 20 18 27 18 8 0 39 16 70 35 30 20 63 39 73 42 9 4 26 16 37 26 11
11 36 30 56 43 147 94 339 298 433 460 275 475 273 1060 -6 1491 -54 83 -181
219 -263 281 -33 25 -62 49 -65 52 -18 22 -276 159 -330 175 -14 4 -43 15 -65
25 -114 50 -369 111 -580 140 -44 6 -90 13 -102 15 -16 4 -26 -1 -35 -19 -11
-21 -12 72 -10 525 l3 549 -154 0 -155 0 -13 -32z m241 -12 c8 -2 -29 -4 -82
-5 -54 0 -98 3 -98 7 0 8 143 6 180 -2z m49 -2 c-13 -13 -15 -34 -12 -117 3
-58 0 -113 -6 -127 -7 -19 -10 8 -10 112 -1 142 -3 137 39 147 2 0 -3 -6 -11
-15z m-22 -456 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2 -33 0 -45z m303
-618 c52 -7 102 -16 111 -20 8 -4 29 -6 45 -3 23 4 26 2 14 -7 -12 -8 -6 -9
25 -5 30 5 36 4 25 -4 -15 -11 3 -15 62 -15 9 0 15 -2 13 -6 -2 -3 17 -12 43
-19 26 -7 57 -17 70 -22 32 -12 51 -11 32 2 -13 9 -13 10 0 5 8 -3 23 -9 33
-12 9 -4 17 -11 17 -16 0 -5 10 -6 21 -3 14 5 19 3 15 -3 -4 -7 8 -14 29 -18
20 -3 32 -10 28 -17 -3 -6 -1 -7 5 -3 14 9 163 -65 155 -77 -3 -6 -1 -7 5 -3
11 7 57 -16 77 -39 6 -6 34 -26 63 -45 28 -18 52 -35 52 -37 0 -2 -5 -1 -12 3
-7 4 -8 3 -4 -4 4 -7 13 -12 21 -12 13 0 165 -143 165 -155 0 -3 12 -18 26
-33 24 -26 60 -86 64 -107 1 -5 16 -39 34 -75 53 -103 65 -135 86 -230 25
-111 25 -150 0 -55 -56 217 -152 393 -298 543 -167 172 -370 292 -653 385 -91
30 -170 48 -419 98 -30 6 -62 15 -70 21 -12 7 -11 8 5 4 11 -2 63 -10 115 -16z
m-339 -47 c-12 -20 -14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m152
-363 l212 -6 -230 1 -230 0 -3 23 c-3 23 -3 23 18 5 18 -16 48 -19 233 -23z
m-1335 -1165 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z m16 -31
c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z m171 -239 c43 -44 113
-97 168 -129 26 -15 47 -30 47 -33 0 -9 -104 52 -139 82 -50 43 -150 141 -126
124 11 -8 34 -28 50 -44z"
          />
          <path
            d="M2157 3019 c-132 -15 -192 -64 -240 -194 -32 -85 -35 -99 -37 -200
-2 -75 5 -118 27 -151 32 -50 184 -84 379 -84 95 0 134 -14 134 -48 0 -10 7
-28 16 -41 25 -36 2 -50 -92 -57 -80 -7 -266 10 -311 27 -18 7 -36 4 -69 -11
l-45 -19 7 -49 c4 -31 2 -52 -4 -56 -16 -10 -26 -91 -14 -113 8 -14 30 -23 84
-33 90 -16 368 -16 446 0 61 13 118 38 108 47 -3 4 16 19 43 34 105 60 137
138 129 307 -5 80 -9 99 -34 140 -33 52 -100 96 -164 106 -21 3 -101 10 -179
16 -79 6 -151 15 -162 20 -22 12 -37 61 -31 102 4 28 5 28 76 28 39 0 100 -5
136 -11 125 -19 152 -18 205 6 28 13 63 37 79 54 l30 31 -15 58 c-19 72 -29
77 -186 91 -135 12 -214 12 -316 0z"
          />
          <path
            d="M2893 3008 l-72 -10 -6 -56 c-3 -32 -8 -73 -10 -93 -5 -41 20 -72 67
-83 47 -11 58 -31 59 -109 1 -40 0 -76 -1 -82 -1 -5 -4 -133 -7 -283 -5 -258
-4 -274 13 -287 22 -17 70 -19 79 -5 4 6 12 10 18 9 23 -2 57 13 57 27 0 7 16
16 38 19 20 4 42 8 48 10 10 3 11 151 5 833 l-1 122 -107 -1 c-60 -1 -140 -6
-180 -11z"
          />
          <path
            d="M6696 3004 c-3 -9 -6 -55 -6 -104 0 -61 -4 -90 -12 -93 -10 -4 -10
-6 0 -6 10 -1 10 -5 -2 -17 -14 -13 -21 -14 -54 -3 -20 7 -73 13 -117 14 -137
0 -212 -45 -250 -151 -9 -27 -21 -58 -26 -69 -23 -55 -30 -143 -24 -278 8
-157 15 -181 76 -251 39 -44 39 -44 123 -51 59 -5 90 -4 107 5 14 8 70 13 147
14 100 1 126 5 136 17 6 9 33 19 60 23 l49 8 -6 416 c-4 229 -7 445 -7 480 l0
62 -94 0 c-76 0 -95 -3 -100 -16z m-111 -406 c61 -21 72 -42 79 -136 3 -48 7
-105 9 -127 7 -77 -35 -115 -123 -115 -37 0 -56 6 -77 24 l-28 24 0 134 c0 73
4 146 8 161 8 30 60 61 87 51 8 -3 29 -11 45 -16z"
          />
          <path
            d="M7810 2970 c-10 -6 -16 -35 -20 -92 l-5 -83 -45 -5 -45 -5 -3 -82
c-2 -53 1 -83 8 -83 5 0 10 -7 10 -15 0 -8 6 -15 14 -15 20 0 27 -47 31 -224
5 -159 22 -264 49 -296 7 -8 16 -23 19 -32 5 -15 18 -17 99 -13 51 3 126 12
166 21 l73 16 -3 82 -3 81 -75 0 -74 0 -8 40 c-9 51 -10 214 -2 292 l7 60 62
5 c35 3 68 9 74 12 12 8 15 96 5 133 -5 20 -14 22 -78 25 l-71 3 0 93 0 92
-85 0 c-47 0 -92 -4 -100 -10z"
          />
          <path
            d="M3785 2790 c-66 -14 -110 -37 -144 -75 -38 -44 -57 -87 -71 -168 -7
-34 -15 -69 -18 -77 -15 -38 -18 -293 -3 -298 6 -2 11 -15 11 -28 0 -13 9 -33
20 -44 11 -11 20 -24 20 -30 0 -5 7 -10 15 -10 8 0 15 -7 15 -15 0 -26 60 -48
190 -67 52 -8 223 33 237 56 5 7 29 23 55 35 67 32 114 91 129 159 6 33 10
121 7 221 -3 155 -5 170 -28 215 -34 66 -99 110 -183 125 -72 12 -192 13 -252
1z m127 -195 c31 -5 41 -13 62 -51 22 -40 25 -58 28 -169 2 -114 1 -126 -17
-139 -26 -20 -117 -20 -154 -1 -44 22 -54 59 -50 198 5 143 19 180 67 172 15
-2 44 -7 64 -10z"
          />
          <path
            d="M5233 2791 c-63 -10 -134 -50 -167 -94 -13 -17 -32 -57 -40 -87 -9
-30 -22 -68 -29 -85 -16 -40 -13 -357 4 -400 7 -16 27 -48 45 -71 27 -33 42
-43 87 -53 75 -17 172 -15 240 3 32 9 67 16 77 16 11 0 19 5 18 11 -2 7 20 20
47 30 56 19 125 72 125 95 0 9 -22 39 -49 67 l-50 52 -56 -28 c-45 -22 -69
-27 -128 -27 -97 0 -137 25 -137 85 0 24 2 27 11 15 6 -9 12 -11 15 -4 3 6 52
9 137 8 75 -1 140 2 151 8 11 6 42 13 70 17 l51 6 0 120 c0 109 -3 125 -26
176 -45 95 -123 137 -264 144 -44 2 -103 0 -132 -4z m37 -189 c0 -5 22 -6 50
-2 39 5 56 2 77 -12 16 -10 25 -18 20 -18 -4 0 0 -11 9 -25 9 -14 15 -28 12
-30 -2 -2 -53 -6 -113 -7 l-110 -3 3 30 c4 33 27 75 42 75 6 0 10 -4 10 -8z"
          />
          <path
            d="M6046 2785 c-21 -7 -53 -28 -71 -45 l-33 -32 -7 41 -7 41 -84 0 -84
0 -1 -60 c-2 -84 -3 -93 -13 -109 -5 -8 -13 -102 -17 -210 -5 -108 -10 -215
-12 -238 -6 -53 9 -134 26 -145 22 -14 107 -10 107 6 0 9 17 16 49 20 31 4 51
12 55 22 3 9 6 111 6 227 0 191 2 215 19 243 22 37 90 64 158 64 l43 0 0 89
c0 72 -3 90 -16 95 -26 10 -76 6 -118 -9z"
          />
          <path
            d="M7208 2789 c-36 -5 -88 -17 -115 -27 l-48 -18 3 -48 c3 -62 21 -98
52 -107 14 -4 19 -7 11 -8 -8 -1 -12 -3 -9 -6 8 -9 38 6 32 16 -4 7 37 14 67
11 3 0 22 3 42 8 20 4 37 5 37 1 0 -4 19 -11 42 -17 31 -6 44 -15 47 -29 2
-11 10 -25 19 -31 12 -8 -11 -12 -99 -16 -167 -8 -251 -47 -282 -130 -8 -24
-20 -87 -26 -140 -10 -102 -3 -156 24 -178 8 -7 15 -19 15 -27 0 -42 139 -56
276 -27 56 12 103 17 124 13 19 -4 42 -3 52 2 10 6 48 15 85 22 l66 12 -2 285
c-2 249 -5 290 -20 326 -33 73 -108 110 -243 118 -46 2 -113 1 -150 -5z m100
-437 c9 -5 28 -14 41 -21 18 -10 21 -10 16 0 -5 8 -4 10 3 5 7 -4 12 -18 12
-31 0 -13 5 -25 11 -27 15 -5 1 -34 -25 -51 -12 -9 -36 -16 -52 -17 -102 -7
-127 8 -122 79 3 43 6 47 38 58 43 15 55 15 78 5z"
          />
          <path
            d="M8490 2794 c-126 -15 -205 -37 -214 -60 -6 -15 21 -112 36 -131 6 -8
29 -10 66 -6 31 3 67 5 80 4 13 0 21 2 18 7 -2 4 15 6 38 6 44 -1 99 -30 104
-54 2 -8 8 -16 13 -18 30 -11 -5 -20 -104 -25 -241 -13 -304 -75 -308 -304 -2
-86 0 -95 25 -132 26 -37 35 -42 103 -57 80 -18 191 -14 204 7 3 6 24 19 46
29 37 16 40 16 50 1 9 -15 22 -16 104 -9 52 5 98 9 102 11 5 1 8 122 7 269 -1
294 -8 343 -57 390 -61 58 -185 87 -313 72z m254 -50 c26 -18 22 -17 -44 7
-49 18 -51 19 -16 14 22 -4 49 -13 60 -21z m-150 -409 c18 -17 26 -34 26 -58
0 -47 -32 -67 -104 -67 -64 0 -86 21 -86 82 0 47 28 68 91 68 35 0 52 -6 73
-25z m-140 -144 c-2 -3 -12 3 -22 13 -16 17 -16 18 5 5 12 -7 20 -15 17 -18z"
          />
          <path
            d="M4287 2748 c4 -24 7 -67 7 -95 -1 -29 2 -53 6 -53 4 0 7 -16 8 -35 1
-19 6 -44 11 -54 6 -10 8 -21 4 -24 -3 -4 -1 -12 5 -19 6 -8 20 -48 31 -91 12
-43 26 -85 31 -95 5 -9 12 -38 15 -64 3 -27 10 -48 14 -48 5 0 12 -20 15 -45
4 -24 11 -47 17 -50 5 -4 9 -15 9 -25 0 -42 91 -71 141 -46 18 9 38 16 46 16
7 0 13 7 13 15 0 10 10 15 28 15 40 0 50 10 73 76 129 364 219 636 219 659 0
3 -45 5 -99 5 l-99 0 -27 -77 c-16 -43 -34 -91 -41 -108 -7 -16 -23 -66 -35
-110 -12 -44 -30 -95 -40 -113 l-17 -33 -32 103 c-18 57 -43 139 -57 183 -13
44 -30 96 -36 115 l-13 35 -103 3 -103 3 9 -43z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
